
import type { PropOptions } from 'vue';
import Vue from 'vue';
import BravadoCallout from '~/components/common/BravadoCallout/BravadoCallout.vue';

export default Vue.extend({
  name: 'PublicPortfolioSection',
  components: { BravadoCallout },
  props: {
    title: {
      type: String,
      default: '',
    } as PropOptions<string>,
    offset: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
    withSeparator: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
  },
  computed: {
    rootClass(): Record<string, boolean> {
      return {
        'public-portfolio-section': true,
        'public-portfolio-section--offset': this.offset,
      };
    },
  },
});
